// extracted by mini-css-extract-plugin
module.exports = {"Order":"ViewOrderDrawer_Order__3XT4Q","Product":"ViewOrderDrawer_Product__2RJw8"};